import React, { useContext, useEffect, useState } from "react";
import {
  Row,
  Column,
  FormGroup,
  TextArea,
  TextInput,
  Form,
  ButtonSet,
  Button,
  SelectItem,
  Select,
  Loading,
} from "carbon-components-react";
import { useForm } from "react-hook-form";
import http from "../../http-common";
import {
  traineeProfileSchema,
  vacancySchema,
} from "../../services/SchemaService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import { AuthContext } from "../../contexts/AuthContext";
import useTraineeProfile from "../../hooks/useTraineeProfile";
import useGet from "../../hooks/useGet";
import GenericCombo from "../../components/Combos/GenericCombo";
import useAuth from "../../hooks/useAuth";

const TraineeProfileForm = () => {
  const { user } = useAuth();
  const { profile } = useTraineeProfile();
  const { data: genders } = useGet("/utils/genders");
  const { data: provinces } = useGet("/utils/provinces");
  const [disabled, setDisabled] = useState(false);
  const [operation, setOperation] = useState("CREATE");
  const navigate = useNavigate();
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(traineeProfileSchema),
    mode: "onBlur",
  });

  const handleProvinceChange = async (e) => {
    if (e.target.value) {
      try {
        const response = await http.get(
          "/utils/provinces/" + e.target.value + "/districts"
        );
        setDistricts(response.data);
      } catch (error) {
        toast.error(error?.response?.data.message);
      }
    } else {
      setDistricts([]);
    }
  };

  const onSubmit = async (data) => {
    try {
      const endPoint = "/internships/trainees";
      // console.log(data);
      const response =
        operation === "CREATE"
          ? await http.post(endPoint, data)
          : await http.put(endPoint, data);
      navigate("../painel-estagiario/");
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
   
    const getDistricts = async () => {
      try {
        const response = await http.get(
          "/utils/provinces/" + profile?.provinceId + "/districts"
        );
        setDistricts(response.data);
      } catch (error) {
        toast.error(error?.response?.data.message);
      }finally {
        setValue("provinceId", profile?.provinceId);
        setValue("districtId", profile?.districtId);
        setLoading(false);
      }
    };
    if(profile?.provinceId){
      getDistricts();
    } else{
      setLoading(false);
    }
    
    reset(profile);
    setValue("phoneNumber1", user.username);
    setValue(
      "name",
      profile ? profile?.name : user.firstName + " " + user.lastName
    );
    setValue("gender", profile?.gender?.code);
   
    setDisabled(profile ? true : false);
    setOperation(profile ? "UPDATE" : "CREATE");
    
  }, [profile]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Loading
        active={loading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <div className="content">
        <strong>
          <div className="content">
            <p>
              {/* <strong>
                Agora Emprega - Competição de Planos de Negócios (CPN) é
                implementada pela Secretaria de Estado da Juventude e Emprego
                (SEJE) através do Instituto Nacional da Juventude (INJ) como
                parte do Programa Emprega, com o apoio do Banco Mundial. O
                objectivo da CPN é facilitar o acesso ao financiamento para
                Moçambicanas e Moçambicanos com idades entre 18 e 35 anos e
                impulsionar o crescimento económico inclusivo.
              </strong> */}
            </p>
            <p>
              {/* <strong>
                A CPN contempla estágios profissionais nas empresas vencedoras,
                como uma das formas de ajudar a impulsionar o emprego e a
                conectividade entre jovens procurando por seu primeiro emprego
                ou procurando melhorar os seus conhecimentos e habilidades
              </strong> */}
            </p>
            <h5 className="mb-1">INSTRUÇÕES GERAIS DE PREENCHIMENTO</h5>
            <p>
              1. <strong>Todas as secções</strong> deste formulário devem ser
              preenchidas com informação correcta e actual antes do envio.
            </p>
            <p>
              2. Ao preencher o formulário de candidatura à estágio, depois de
              concluído,{" "}
              <strong>
                lembre-se de sempre salvar e proceder ao seu envio
              </strong>
              .
            </p>
            <p>
              3. A equipa de implementação da CPN acusará o recebimento deste
              formulário através do endereço de email do candidato apresentado
              neste formulário.
            </p>
            <p>
              4. Ao longo do processo é possível que seja contactado por um
              representante da nossa equipa ou das empresas para as quais tenha
              concorrido, para fornecer mais informações.
            </p>
            <p>
              5. Por favor,{" "}
              <strong>
                reconfirme que o endereço de e-mail de contato do candidato
                principal e o número de telefone inseridos no formulário estão
                correctos
              </strong>
              .
            </p>
            <p>
              Se o candidato a estágio tiver alguma dúvida sobre a sua
              candidatura, não hesite em nos enviar um e-mail a solicitar
              esclarecimentos através de agoraemprega@seje.gov.mz . O candidato
              receberá uma resposta em 36 horas úteis através do website.
              Alternativamente, o candidato pode ligar para a seguinte linha de
              apoio: <strong>85 730 5231 / 87 730 5236</strong>
            </p>
          </div>
        </strong>
      </div>
      <FormGroup
        legendText="SECÇÃO A: DADOS PESSOAIS DO CONCORRENTE AO ESTÁGIO PROFISSIONAL"
        className="section-header"
      >
        <Row>
          <Column sm={12} md={6} lg={6} className="required">
            <TextInput
              id="name"
              labelText="A.1: Nome"
              disabled={disabled}
              {...register("name")}
            />
            <p className="field-error">{errors.name?.message}</p>
          </Column>
          <Column sm={12} md={3} lg={3} className="required">
            <TextInput
              id="birthDate"
              labelText="A.2: Data de nascimento (dd/mm/aaaa)"
              disabled={disabled}
              {...register("birthDate")}
            />
            <p className="field-error">{errors.birthDate?.message}</p>
          </Column>
          <Column sm={12} md={3} lg={3} className="required">
            <GenericCombo
              id="gender"
              name="gender"
              label="A3. Sexo"
              disabled={disabled}
              register={register}
              items={genders}
            />
            <p className="field-error">{errors.gender?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={3} lg={3} className="required">
            <TextInput
              id="identificationDocNumber"
              labelText="A.4: Bilhete de Identidade"
              disabled={disabled}
              maxLength={13}
              {...register("identificationDocNumber")}
            />
            <p className="field-error">
              {errors.identificationDocNumber?.message}
            </p>
          </Column>
          <Column sm={12} md={3} lg={3} className="required">
            <TextInput
              id="nuit"
              labelText="A.5: NUIT"
              disabled={disabled}
              maxLength={9}
              {...register("nuit")}
            />
            <p className="field-error">{errors.nuit?.message}</p>
          </Column>
          <Column sm={12} md={6} lg={6} className="required">
            <TextInput
              id="residence"
              labelText="A.6: Residência"
              disabled={disabled}
              {...register("residence")}
            />
            <p className="field-error">{errors.residence?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <Select
              id="provinceId"
              labelText="Província"
              disabled={disabled}
              {...register("provinceId")}
              onChange={handleProvinceChange}
            >
              <SelectItem text="" value="" />
              {provinces.map((p) => (
                <SelectItem text={p.description} value={p.id} key={p.id} />
              ))}
            </Select>
            <p className="field-error">{errors.provinceId?.message}</p>
          </Column>

          <Column xml={12} sm={6} md={3} lg={3} className="required">
            <Select
              id="districtId"
              name="districtId"
              labelText="Cidade/Distrito"
              disabled={disabled}
              // value={application?.districtId || ""}
              {...register("districtId")}
            >
              <SelectItem text="" value="" />
              {districts.map((p) => (
                <SelectItem text={p.description} value={p.id} key={p.id} />
              ))}
            </Select>
            <p className="field-error">{errors.districtId?.message}</p>
          </Column>
          <Column xml={12} sm={6} md={6} lg={6}>
            <TextInput
              id="locality"
              labelText="Localidade"
              name="locality"
              maxLength={128}
              disabled={disabled}
              {...register("locality")}
            />
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={3} lg={3} className="required">
            <TextInput
              id="phoneNumber1"
              labelText="A.7: Telemóvel"
              disabled={true}
              {...register("phoneNumber1")}
            />
            <p className="field-error">{errors.phoneNumber1?.message}</p>
          </Column>
          <Column sm={12} md={3} lg={3}>
            <TextInput
              id="phoneNumber2"
              labelText="A.7: Telemóvel alternativo"
              disabled={disabled}
              {...register("phoneNumber2")}
            />
            <p className="field-error">{errors.phoneNumber2?.message}</p>
          </Column>
          <Column sm={12} md={6} lg={6} className="required">
            <TextInput
              id="email"
              labelText="A.8: Email"
              disabled={disabled}
              {...register("email")}
            />
            <p className="field-error">{errors.email?.message}</p>
          </Column>
        </Row>
      </FormGroup>
      <FormGroup legendText="SECÇÃO B" className="section-header">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="education"
              labelText="B.1: Educação"
              helperText="[Descreva a sua formação académica, escreva os níveis que concluiu e as respectivas datas de conclusão e instituição de ensino]"
              rows={5}
              enableCounter
              disabled={disabled}
              {...register("education")}
            />
            <p className="field-error">{errors.education?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="courses"
              labelText="B.2: Cursos adicionais/complementares/certificados"
              helperText="[Descreva os cursos adicionais e capacitações que tenha realizado, as instituições e respectivas datas; Inclua também aqui os Softwares que domina]"
              rows={5}
              enableCounter
              disabled={disabled}
              {...register("courses")}
            />
            <p className="field-error">{errors.courses?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="experience"
              labelText="B.3: Experiência Profissional "
              helperText="[Descreva os empregos ou experiências profissionais prévias que teve, listando: a empresas, a duração, as principais actividades que realizou]"
              rows={5}
              enableCounter
              disabled={disabled}
              {...register("experience")}
            />
            <p className="field-error">{errors.experience?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="languages"
              labelText="B.4: Idiomas"
              helperText="[Liste as línguas nas quais pode trabalhar (falar, ler, escrever)]"
              rows={5}
              enableCounter
              disabled={disabled}
              {...register("languages")}
            />
            <p className="field-error">{errors.languages?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="skills"
              labelText="B.5: Habilidades comportamentais/atitudes"
              helperText="[Liste os principais comportamentos, atitudes e habilidades sociais que possui que são relevantes para o ambiente profissional ]"
              rows={5}
              enableCounter
              disabled={disabled}
              {...register("skills")}
            />
            <p className="field-error">{errors.skills?.message}</p>
          </Column>
        </Row>
      </FormGroup>
      <Row>
        <Column sm={12} md={12} lg={12} className="form-buttons">
          <ButtonSet>
            {disabled && (
              <Button
                type="button"
                onClick={() => {
                  setDisabled(false);
                }}
              >
                Editar
              </Button>
            )}
            {!disabled && <SubmitButton />}
            <CancelButton />
          </ButtonSet>
        </Column>
      </Row>
    </Form>
  );
};

TraineeProfileForm.defaultProps = {
  disabled: false,
};

export default TraineeProfileForm;
